// use jquery from wordpress. place in module if needed
window.$ = window.jQuery = jQuery;

import { lazy } from './helpers/lazyLoading';
import { buildNavigation } from './modules/buildNavigation';
import { headerVisuals } from './modules/headerVisuals';
import { handleBlog } from './modules/handleBlog';
import { fillerScroll } from './modules/fillerScroll';
import hljs from 'highlight.js';

//*******************************************************
// STRIPES
//*******************************************************

headerVisuals();

//*******************************************************
// scroll filler
//*******************************************************

fillerScroll();

//*******************************************************
// lazy loading
//*******************************************************

lazy();

//*******************************************************
// NAV
//*******************************************************

buildNavigation();

//*******************************************************
// blog
//*******************************************************

handleBlog();

//*******************************************************
// highlight.js
//*******************************************************

hljs.highlightAll();
